import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/spaces/$spaceId/')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['spaces:manage', 'spaces:access-read-only'])
    ) {
      throw redirect({ params: { spaceId: params.spaceId }, to: '/settings/spaces/$spaceId/sites' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/spaces/pages/space-general-page')),
});
